import styled from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Config from '@config';

// data-id lets useGridTemplateColumns find the grid inside a parent ref
const Grid = styled.div.attrs<{ 'data-id'?: string }>({ 'data-id': 'grid' })`
  display: grid;
  // minmax(0, 1fr) instead of 1fr, so a column can't grow wider than its share because of what's in it, which
  // pushed the grid off the right edge of the screen on 360px wide phones
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${rem(12)};
  margin: 0 0 ${rem(16)};

  // On the smallest screens the cards go edge to edge: pulled out over the container padding, with no gap
  ${Config.MEDIA.IS_MOBILE_XSMALL} {
    margin-inline: ${rem(-variables.size.containerPaddingMobileSmall)};
    gap: 0;
  }

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-bottom: ${rem(26)};
  }

  ${Config.MEDIA.FROM_TABLET_LANDSCAPE} {
    grid-template-columns: repeat(auto-fill, minmax(${rem(223)}, 1fr));
  }

  ${Config.MEDIA.FROM_DESKTOP} {
    grid-template-columns: repeat(auto-fill, minmax(${rem(190)}, 1fr));
    gap: ${rem(16)};
  }
`;

export default Grid;
